import { FC } from 'react';
import Image from 'next/image';

import { Emoji } from '@/utils/functions';
import styles from './Rating.module.css';

interface RatingItemProps {
  logoSrc: string;
  text: string;
  link: string;
  onRateClick: () => void;
}

interface RatingProps {
  onRateClick: () => void;
}

const RATING_LIST_DATA = [
  {
    logoSrc: '/assets/trustpilot.svg',
    text: 'Trustpilot',
    link: 'https://au.trustpilot.com/evaluate/relaypay.io',
  },
  {
    logoSrc: '/assets/google.svg',
    text: 'Google',
    link: 'https://g.page/r/CWd3dqSyQlzAEBM/review',
  },
  {
    logoSrc: '/assets/product-review.svg',
    text: 'ProductReview',
    link: 'https://www.productreview.com.au/listings/relaypay/write-review',
  },

  // {
  //   logoSrc: '/assets/finder-review.svg',
  //   text: 'Finder',
  //   link: 'https://www.finder.com.au/cryptocurrency/exchanges/relaypay-cryptocurrency-review#your-reviews',
  // },
];

const RatingItem: FC<RatingItemProps> = ({ link, logoSrc, text, onRateClick }) => {
  return (
    <li className={styles.listItem}>
      <a onClick={onRateClick} className={styles.item} href={link} target="_blank" rel="noreferrer">
        <div className={styles.imageBox}>
          <Image className={styles.socialLogo} src={logoSrc} fill alt="Rate Social Logo" />
        </div>
        <p>{text}</p>
      </a>
    </li>
  );
};

export const Rating: FC<RatingProps> = ({ onRateClick }) => {
  return (
    <div className={styles.container}>
      <Image className={styles.image} src={'/assets/rate-us.svg'} width={229} height={119} alt="Rate Us Logo" />
      <h3 className={styles.title}>{<Emoji symbol="⭐" className={styles.emoji} />} Please help us grow with 5 stars on:</h3>
      <ul className={styles.list}>
        {RATING_LIST_DATA.map((item, index) => (
          <RatingItem link={item.link} logoSrc={item.logoSrc} text={item.text} key={index} onRateClick={onRateClick} />
        ))}
      </ul>
    </div>
  );
};
